import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

export const RequiredDocumentGeneralDataComponent = ({ requiredDocument, onPropertyChanged, contentTypes, validation }) => {
  const [t] = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={requiredDocument.documentName || ''}
          onChange={event => onPropertyChanged('documentName', event)}
          label={t('RequiredDocument.DocumentName')}
          error={!isValid(validation.documentName)}
          helperText={getErrors(validation.documentName)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={requiredDocument.documentCode || ''}
          onChange={event => onPropertyChanged('documentCode', event)}
          label={t('RequiredDocument.DocumentCode')}
          error={!isValid(validation.documentCode)}
          helperText={getErrors(validation.documentCode)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          value={requiredDocument.sharePointContentType}
          options={contentTypes}
          simpleValue
          label={t('RequiredDocument.SharePointContentType')}
          onChange={event => onPropertyChanged('sharePointContentType', event)}
          error={!isValid(validation.sharePointContentType)}
          helperText={getErrors(validation.sharePointContentType)}
          isSearchable={true}
        />
      </Grid>
    </Grid>
  );
};

RequiredDocumentGeneralDataComponent.propTypes = {
  requiredDocument: PropTypes.object.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  contentTypes: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default RequiredDocumentGeneralDataComponent;
